import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

import { HeaderBackButton } from "../../../components/BackButton";
import { CustomButton } from "../../../components/CustomButton";
import {
  DownloadCollectionYardVisitReceipt,
  DownloadVariant,
} from "../../../components/DownloadCollectionYardVisitReceipt/DownloadCollectionYardVisitReceipt";
import { PaymentStatusButton } from "../../../components/PaymentStatusButton";
import { COLLECTION_POINT_PAGE_PATH } from "../../../middleware/routes";
import { updateYardVisitIsPaidStatusThunk } from "../../../reducers/collectionYardsVisitsDetailReducer";
import { getCollectionPointDetail } from "../../../selectors/collectionPoint";
import { getCollectionYardVisitEventsSummary } from "../../../selectors/collectionYardVisitEvents";
import { IUpdateVisitIsPaidStatusRequest } from "../../../types/collectionYards";
import { PREV_PAGE_PARAM } from "../../../utils/url";

import styles from "./CollectionYardVisitEventsPageHeaderComponent.module.scss";

export const CollectionYardVisitEventsPageHeaderComponent: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const { locationId } = useSelector(getCollectionPointDetail);
  const summary = useSelector(getCollectionYardVisitEventsSummary);

  if (!summary) {
    return null;
  }

  const { collectionYardName, collectionYardVisitId, paidAt, priceSum, created } = summary;
  const isDownloadDisabled = !priceSum || priceSum <= 0;
  const formattedDateTime = dayjs(created).format("DD. MM. YYYY HH:mm");

  const getBackTo = () => {
    const queryParams = new URLSearchParams(location.search);
    const prevPageValue = queryParams.get(PREV_PAGE_PARAM);

    return prevPageValue || `${COLLECTION_POINT_PAGE_PATH}?id=${locationId}`;
  };

  const isPaid = Boolean(paidAt);
  const payload: IUpdateVisitIsPaidStatusRequest = {
    collection_yard_visit_id: collectionYardVisitId,
    isPaid: !isPaid,
  };

  return (
    <div className={styles.container}>
      <HeaderBackButton backTo={getBackTo()} title={collectionYardName} subtitle={formattedDateTime} />
      <div className={styles.center}>
        {priceSum > 0 && <p>{t("isPaid")}</p>}
        <div className={styles.buttonsContainer}>
          <PaymentStatusButton
            isPaid={isPaid}
            paidAt={paidAt}
            translationKey={"collectionYardVisit.paymentModal"}
            payload={payload}
            thunk={updateYardVisitIsPaidStatusThunk}
            isVisible={priceSum > 0}
          />
        </div>
      </div>
      <div className={styles.controlsWrapper}>
        <DownloadCollectionYardVisitReceipt visitId={collectionYardVisitId} variant={DownloadVariant.button}>
          <CustomButton text={t("collectionYardVisitEvents.downloadReceipt")} disabled={isDownloadDisabled} />
        </DownloadCollectionYardVisitReceipt>
      </div>
    </div>
  );
};
